export default (props) => (
  <svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM18 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    />
  </svg>
);
